import { render, staticRenderFns } from "./ViewAttachments.vue?vue&type=template&id=294aaab2&scoped=true&"
import script from "./ViewAttachments.vue?vue&type=script&lang=js&"
export * from "./ViewAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294aaab2",
  null
  
)

export default component.exports